import { Pipe, PipeTransform } from '@angular/core';
import { ArtistShow } from '../models/artist/artist-show';

@Pipe({
  name: 'artistShows',
  standalone: false,
})
export class ArtistShowsPipe implements PipeTransform {
  transform(
    artistShows: ArtistShow[],
    type: 'upcoming' | 'past' = 'upcoming',
  ): ArtistShow[] {
    if (!artistShows) {
      return artistShows;
    }

    return artistShows
      .filter((artistShow) => {
        const now = new Date();
        if (type === 'upcoming') {
          return new Date(artistShow.date).getTime() > now.getTime();
        } else {
          return new Date(artistShow.date).getTime() < now.getTime();
        }
      })
      .sort((a, b) => {
        if (type === 'upcoming') {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        } else {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        }
      });
  }
}
